import React                from 'react';
import { Link }             from 'react-router-dom';
import moment               from 'moment';
import Card                 from '@mui/material/Card';
import CardContent          from '@mui/material/CardContent';
import CardMedia            from '@mui/material/CardMedia';
import Button               from '@mui/material/Button';
import Typography           from '@mui/material/Typography';
import CardActions          from '@mui/material/CardActions';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import '../../../app.min.css';

//image="https://i.imgur.com/bxKqibc.jpg"
//<div style={{display: "flex", justifyContent: 'flex-end', padding: "0 10px 10px 0", alignItems: 'center', color: 'indigo'}}>
//<Card style={{borderRadius: 10, margin: "10px 10px 10px 10px", backgroundColor: "#ebf6f7", boxShadow: 'none'}}>
export default function BlogCard (props) {
	const { data } = props;

	return (
		<Card style={{borderRadius: 2, margin: "10px 10px 10px 10px"}}>
			<Link to={data.url} style={{textDecoration: 'none', color: 'black'}}>
				<CardMedia
					component="img"
					alt={data.img_alt || "not found"}
					height="300"
					image={data.img}
				/>
			</Link>
				<CardContent>
					<Typography gutterBottom variant="h5" component="div">
						<Link to={data.url} className='anchorTitle font'>{data.title}</Link>
					</Typography>
					<Typography variant="body2" color="text.secondary">
						<span className='text'>{data.short_desc &&
							data.short_desc.length ? data.short_desc.slice (0,300) : "No Description."}...
						</span>
					</Typography>
				</CardContent>
				<CardActions>
					<Button component={Link} size="medium" to={data.url}><span className='btn'>Read More</span></Button>
				</CardActions>
				<div className='readTimestamp'>
					<AccessTimeFilledIcon />
					&nbsp;
					{moment (data.updatedAt).format ('DD.MM.YYYY')}
				</div>
		</Card>
	);
}
